/**
 * Cookie utility functions for reading and managing cookies
 * Used for CSRF token and other cookie-based authentication
 */

/**
 * Read a cookie value by name
 * @param name Cookie name
 * @returns Cookie value or null if not found
 */
export function getCookie(name: string): string | null {
  if (typeof document === 'undefined') return null;
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop()?.split(';').shift() || null;
  }
  return null;
}

/**
 * Check if a cookie exists
 * @param name Cookie name
 * @returns True if cookie exists, false otherwise
 */
export function hasCookie(name: string): boolean {
  return getCookie(name) !== null;
}

/**
 * Delete a cookie
 * @param name Cookie name
 * @param domain Optional domain (e.g., '.clanda.de')
 * @param path Cookie path (default: '/')
 */
export function deleteCookie(name: string, domain?: string, path: string = '/'): void {
  if (typeof document === 'undefined') return;
  let cookieString = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=${path}`;
  if (domain) {
    cookieString += `;domain=${domain}`;
  }
  document.cookie = cookieString;
}

